import { TOPIC_PAGE, TOPIC_PAGE_PATH_PREFIX } from '@townsquare/config/routes';
import { createSiteRoute } from '@townsquare/router/create-route';

export const topicRoute = createSiteRoute({
	exact: true,
	name: TOPIC_PAGE,
	path: `${TOPIC_PAGE_PATH_PREFIX}/:uuid/:tabName?/:viewMode?`,
	subproduct: 'townsquare-topics',
});
